module.exports = __webpack_public_path__ + "0343a0b65d8c3440ee86dc89db02e1ef.pdf";